import clsx from 'clsx'
import { FC } from 'react'
import { ClassName } from 'types/props'

import classes from './index.module.scss'

interface Props extends ClassName {
  variant: 'primary'
}

export const Pill: FC<Props> = ({ children, className, variant }) => {
  if (children === 0) return null
  return <span className={clsx(classes.root, classes[variant], className)}>{children}</span>
}
